<template>
    <div class="col-md-6 m-b">
        <div class="form-group">
            <label>{{ name }}</label>
            <div class="preview">
                <span class="text-muted" v-if="(picture.length == 0 && value_inner.length == 0) || value_inner == 'delete'">{{ t_no_picture }}</span>
                <img class="img-lg" v-else-if="picture.length > 0" alt="" :src="'/storage/fields/'+project_id+'/'+picture" />
                <img class="img-lg" v-else-if="value_inner.length > 0" alt="" :src="value_inner" />
            </div>
        </div>
        <div class="btn-group btn-block">
            <label :title="t_upload_picture" class="btn btn-primary btn-upload btn-block m-r-sm">
                <input type="file" accept="image/jpeg,image/png" :name="'dynamic_field_'+id" :title="name" class="hidden" @change="upload">
                {{ t_upload_picture }}
            </label>
            <div class="left btn btn-white btn-delete"
                 v-if="(picture.length > 0 || value_inner.length > 0) && value_inner !== 'delete'"
                 @click="deleteFile()">
                <i class="fa-regular fa-trash"></i>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['id', 'name', 'value', 'error'],
        data: function() {
            return {
                t_no_picture: Lang.langGet("No picture uploaded."),
                t_upload_picture: Lang.langGet("Upload Picture"),
                picture: this.value,
                value_inner: '',
                project_id: Laravel.activeProject,
            }
        },
        methods: {
            upload: function(e) {
                let files = e.target.files || e.dataTransfer.files;
                if (!files.length) {
                    return;
                }
                this.createImage(files[0]);
            },
            createImage(file) {
                let image = new Image();
                let reader = new FileReader();

                reader.onload = (e) => {
                    this.value_inner = e.target.result;
                };
                reader.readAsDataURL(file);
                this.picture = '';
            },
            deleteFile: function () {
                this.value_inner = 'delete';
            }
        },
        watch: {
            value_inner: function(val,oldVal){
                this.$emit('input',val);
            }
        }
    }
</script>
